import { useNavigate, Navigate, useSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { postRequestAsync } from '../../../common/genericAPIs'
import { setLoader, setSnackbar } from '../../../redux/common'
import { setIsRequestCreationInProcess } from '../../../redux/request'
import { getFromLocalStorage } from '../../../utils/localStorage'
import { setUserDetails } from '../../../redux/user'
import NewUserDetailsForm from '../../../common/components/NewUserDetailsForm'
import loginStyles from '../Login.module.scss'
import { Card } from 'sfy-react'

const NewUserDetails = ({ showEmail }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const appConfigDetails = useSelector((state) => state.common.appConfigDetails)
  const selectedCountryDetails = useSelector((state) => state.common.selectedCountryDetails)
  const loginFields = useSelector((state) => state.login.fields)

  const handleOnSubmit = async (e, fields) => {
    try {
      e.preventDefault()
      dispatch(setLoader(true))
      let payload = {}
      if (appConfigDetails.enableEmailLogin) {
        payload.mobileNo = fields.mobileNumber
        payload.phoneCode = `+${selectedCountryDetails.phoneCode}`
      } else {
        payload.emailID = fields.email
      }
      await postRequestAsync(
        '/consumer/update',
        {
          consumerID: +getFromLocalStorage('consumerID'),
          updateObj: {
            name: fields.name,
            ...payload,
          },
        },
        'consumer'
      )
      const response = await postRequestAsync(
        '/consumer/fetch',
        {
          consumerID: +getFromLocalStorage('consumerID'),
        },
        'consumer'
      )
      dispatch(setUserDetails(response))
      searchParams.get('redirect')?.includes('request') && dispatch(setIsRequestCreationInProcess(true))
      navigate(searchParams.get('redirect') ? searchParams.get('redirect') : appConfigDetails?.afterLoginpage || '/')
      dispatch(setLoader(false))
    } catch (e) {
      console.log(e)
      dispatch(setSnackbar({ message: e.msg, type: 'error' }))
      dispatch(setLoader(false))
    }
  }

  return loginFields.consent ? (
    <Card className={loginStyles['small-cards']}>
      <NewUserDetailsForm showEmail={showEmail} handleOnSubmit={handleOnSubmit} />
    </Card>
  ) : (
    <Navigate to='/login' replace />
  )
}

export default NewUserDetails
